(() => {
    function wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    function tabih() {

        let elm = document.getElementsByClassName('ih-tabs');

        for (let i = 0; i < elm.length; ++i) {
            let activeTab = 0;
            let elments = elm[i];
            let article = elments.getElementsByTagName('article');
            let allTabs = article.length;

            let dom_html = '<ul class="ih-tabs-nav">';
            for (let c = 0; c < allTabs; ++c) {
                let article_attr = article[c];
                let attr = article_attr.getAttribute('data-tab-name');
                let active = article_attr.getAttribute('data-tab-active');
                let color = article_attr.getAttribute('data-tab-color') ? 'color-' + article_attr.getAttribute('data-tab-color') : '';
                if (!active) {
                    dom_html += '<li class="'+color+'" data-click="' + attr + '">' + attr + '</li>';
                } else {
                    activeTab = c;
                    dom_html += '<li class="active '+color+'" data-click="' + attr + '">' + attr + '</li>';
                    article_attr.classList.add('active');
                }
            }
            dom_html += '</ul>';

            var container = document.createElement('div');
            var att = document.createAttribute('class'); // Create a "class" attribute
            att.value = 'ih-group'; // Set the value of the class attribute
            container.setAttributeNode(att);

            wrap(elments, container);

            elments.insertAdjacentHTML('beforeBegin', dom_html); // SET Navigation Before
            ihdefault(elments);

            // swipe
            let min_horizontal_move = 30;
            let max_vertical_move = 30;
            let within_ms = 1000;
            let start_xPos;
            let start_yPos;
            let start_time;
            elments.addEventListener('touchstart', function (event) {
                start_xPos = event.touches[0].pageX;
                start_yPos = event.touches[0].pageY;
                start_time = new Date();
            });

            elments.addEventListener(
                'touchend',
                function (event) {
                    var end_xPos = event.changedTouches[0].pageX;
                    var end_yPos = event.changedTouches[0].pageY;
                    var end_time = new Date();
                    let move_x = end_xPos - start_xPos;
                    let move_y = end_yPos - start_yPos;
                    let elapsed_time = end_time - start_time;
                    if (
                        Math.abs(move_x) > min_horizontal_move &&
                        Math.abs(move_y) < max_vertical_move &&
                        elapsed_time < within_ms
                    ) {
                        if (move_x < 0) {
                            //left
                            if (activeTab >= allTabs - 1) {
                                activeTab = 0;
                            } else {
                                activeTab += 1;
                            }
                        } else {
                            //right
                            if (activeTab <= 0) {
                                activeTab = allTabs - 1;
                            } else {
                                activeTab -= 1;
                            }
                        }
                        const activateTab = elments.previousSibling.querySelectorAll('li')[activeTab];
                        triggerEvent(activateTab, 'click');
                    }
                },
                false
            );

            let prev = document.getElementsByClassName('product-tabs__button--prev');
            prev[0].addEventListener('click', function () {
                if (activeTab <= 0) {
                    activeTab = allTabs - 1;
                } else {
                    activeTab -= 1;
                }
                const activateTab = elments.previousSibling.querySelectorAll('li')[activeTab];
                triggerEvent(activateTab, 'click');
            });
            let next = document.getElementsByClassName('product-tabs__button--next');
            next[0].addEventListener('click', function () {
                if (activeTab >= allTabs - 1) {
                    activeTab = 0;
                } else {
                    activeTab += 1;
                }
                const activateTab = elments.previousSibling.querySelectorAll('li')[activeTab];
                triggerEvent(activateTab, 'click');
            });

        }
    }
    function triggerEvent(el, type) {
        if ('createEvent' in document) {
            // modern browsers, IE9+
            var e = document.createEvent('HTMLEvents');
            e.initEvent(type, false, true);
            el.dispatchEvent(e);
        } else {
            // IE 8
            var e = document.createEventObject();
            e.eventType = type;
            el.fireEvent('on' + e.eventType, e);
        }
    }
    function ihdefault(elments) {
        let lis = elments.previousSibling.getElementsByTagName('li');

        for (let i = 0; i < lis.length; ++i) {
            let lisi = lis[i];

            lisi.addEventListener('click', function () {
                let click = this.getAttribute('data-click');
                let open = elments.querySelector('[data-tab-name="' + click + '"]');
                open.classList.add('active');
                let article = elments.getElementsByTagName('article');
                for (let c = 0; c < article.length; ++c) {
                    let article_attr = article[c];
                    if (article_attr.getAttribute('data-tab-name') !== click) {
                        article_attr.classList.remove('active');
                    }
                }
                for (let b = 0; b < lis.length; ++b) {
                    let lisi_remove = lis[b];
                    lisi_remove.classList.remove('active');
                }

                this.classList.add('active');
            });

        }
    }

    tabih();
})();
